<template>
  <div class="navMenu"> 
            <label v-for="navMenu in navMenus" style="width: 200px;">
              <!--只有一级菜单-->
              <el-menu-item v-if="navMenu.grade==='1'&&navMenu.menu_name=='用户设置'"
                            :key="navMenu.pk_menu" :data="navMenu" :index="navMenu.menu_path " :route="navMenu.menu_path"
                            >
                <!-- <router-link :to="{path:navMenu.menu_path}"> -->
                  <!--图标-->
                <i :class="navMenu.icon"></i>
                <!--标题-->
                <span slot="title">{{navMenu.menu_name}}</span>
                <!-- </router-link> -->
              </el-menu-item>
              <!--只有二级菜单-->
              <el-menu-item v-else-if="navMenu.grade==='2'"
                            :key="navMenu.pk_menu" :data="navMenu" :index="navMenu.menu_path " :route="navMenu.menu_path"
                            >
                <!-- <router-link :to="{path:navMenu.menu_path}"> -->
                  <!--图标-->
                <i :class="navMenu.icon"></i>
                <!--标题-->
                <span slot="title">{{navMenu.menu_name}}</span>
                <!-- </router-link> -->
              </el-menu-item>

              <!--有多级菜单-->
              <el-submenu v-else-if="navMenu.grade==='1'&&navMenu.children.length>0"
                          :key="navMenu.pk_menu" :data="navMenu" :index="navMenu.pk_menu">
                <template slot="title">
                  <i :class="navMenu.icon"></i>
                  <span> {{navMenu.menu_name}}</span>
                </template>
                <!--递归组件，把遍历的值传回子组件，完成递归调用-->
                <nav-menu :navMenus="navMenu.children"></nav-menu>
              </el-submenu>
            </label>  
  </div>
</template>

<script>
export default {
  name: 'NavMenu', //使用递归组件必须要有
  props: ['navMenus'], // 传入子组件的数据
  data () {
    return {
      
    }
  },
      methods: {}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NavMenu.vue